import { ToastError } from 'helpers/constants';
import { fireToast } from 'helpers/Toasts';
import { greenlightRegistrationLookup } from 'api/historyCheck';
import { formatAuthorizationHeader } from 'helpers/auth';
import { useAuthOptions } from 'hooks/useAuthOptions';
import { useState } from 'react';
import { GreenlightRegistrationLookupResponse } from 'api/historyCheck.typed';

export function useGreenlightRegistrationLookup() {
  const { accessToken } = useAuthOptions();
  const [vehicleData, setVehicleData] =
    useState<GreenlightRegistrationLookupResponse | null>(null);
  const handleSubmitError = (text: string = ToastError.REGULAR) => {
    fireToast({ type: 'ERROR', text });
    setVehicleData(null);
  };

  async function registrationLookup(registration: string) {
    try {
      const lookupResponse = await greenlightRegistrationLookup(
        registration,
        formatAuthorizationHeader(accessToken),
      );
      if (lookupResponse.data?.errorMessage) {
        handleSubmitError(lookupResponse.data?.errorMessage);
      } else {
        setVehicleData(lookupResponse.data);
      }
    } catch (error) {
      handleSubmitError();
    }
  }

  return {
    registrationLookup,
    vehicleData,
  };
}
